import React, { useMemo } from "react";
import { mfServer } from "@account/configs";
import { config } from "../frontends/external-auth-legacy/package.json.js";
import { createReactClient } from "@astro-mf/client/react";
import { instana } from "@crystal/analytics";
import { MicrofrontendClient } from "@crystal/core";
import { useFeatureFlags, FeatureFlagsProvider } from "@crystal/feature-flags";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import { initializeHost } from "../store/state/initialization.js";
import "../store/state/host.js";
import "../store/state/modal.js";
import { Loader } from "./Loader.js";
import { getMfServer, getFlagContext } from "./utils.js";
const ExternalAuthAstroClient = createReactClient({
  mfId: "external-auth",
  server: getMfServer("/external-auth/mf"),
  ErrorView() {
    return /* @__PURE__ */ React.createElement("div", null, "Failed to load External Auth");
  },
  onError(error) {
    instana("reportError", error, {
      meta: {
        errorId: "ExternalAuthMF_Error",
        mfId: "external-auth"
      }
    });
  }
});
const ExternalAuthClient = (props) => {
  useMemo(() => {
    initializeHost({
      context: props.context
    });
  }, []);
  const mfId = config.mfId;
  const flags = useFeatureFlags();
  const isFlagsReady = Object.keys(flags).length > 0;
  const mfServer$1 = mfServer.evaluateWithContext(props.context);
  const mfProps = {
    mfId,
    mfServer: mfServer$1,
    ...props
  };
  const onError = (error) => {
    instana("reportError", error, {
      meta: {
        errorId: "ExternalAuthMF_Error",
        mfId
      }
    });
  };
  if (flags.ACCOUNT_PORTAL_LEGACY) {
    return /* @__PURE__ */ React.createElement(
      MicrofrontendClient,
      {
        mfId,
        mfServer: mfServer$1,
        mfProps,
        mfConfig: config,
        onError,
        ...props
      },
      /* @__PURE__ */ React.createElement(Loader, null)
    );
  }
  return /* @__PURE__ */ React.createElement(
    ExternalAuthAstroClient,
    {
      env: props.context.env,
      locale: props.context.locale,
      render: isFlagsReady,
      styleDependencies: props.loadStyleDependencies,
      ...props
    },
    /* @__PURE__ */ React.createElement(Loader, null)
  );
};
const ExternalAuthPage = (props) => {
  return /* @__PURE__ */ React.createElement(FeatureFlagsProvider, { context: getFlagContext(props.context), project: "account-acquisition" }, /* @__PURE__ */ React.createElement(ExternalAuthClient, { ...props }));
};
export {
  ExternalAuthClient,
  ExternalAuthPage
};
//# sourceMappingURL=ExternalAuthPage.js.map
